import * as PopoverPrimitive from "@radix-ui/react-popover";
import clsx from "clsx";
import { popoverContent } from "./Popover.css";

/**
 * A floating panel anchored to a trigger. Unlike `DropdownMenu`, the panel is
 * not a menu: it holds arbitrary content — inputs, selects, sliders — and
 * doesn't steal typed characters for item typeahead.
 */
export function Popover(
  props: React.ComponentProps<typeof PopoverPrimitive.Root>
) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

export function PopoverTrigger(
  props: React.ComponentProps<typeof PopoverPrimitive.Trigger>
) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

export function PopoverContent({
  align = "end",
  sideOffset = 4,
  className,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    // Portalled: toolbars and sheets clip their overflow, which would cut the
    // panel off at the row's edge.
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={clsx(popoverContent, className)}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
